<template>

    <div  class="bg-sn-light-grey min-h-screen">
        <div class="fixed transition-all z-10 duration-200 w-full h-full lg:hidden top-0 left-0 bg-black bg-opacity-75" :class="{'pointer-events-none opacity-0': !sidebarOpen}" @click.exact="sidebarOpen = false;">

        </div>

        <header class="fixed z-30 top-0 left-0 w-full">
            <Container class="hidden bg-sn-light-grey lg:flex h-[26px] justify-between items-center border-b border-[rgba(0,0,0,0.05)]">
                <a target="_blank" href="https://www.smith-nephew.com" class="text-xs">Corporate Website</a>

                <span class="inline-flex items-center gap-1 text-xs">
                    <img class="flex-shrink-0 mr-1" src="/img/united-kingdom.png" alt="">
                    <span>United Kingdom</span>
                    |
                    <span>English</span>
                </span>
            </Container>

            <div class="bg-white border-b border-[rgba(0,0,0,0.05)]">
                <Container>
                    <div class="relative flex py-3 justify-center items-center h-[72px]">
                        <img v-if="!sidebarOpen" @click="sidebarOpen = !sidebarOpen" class="absolute left-0 lg:hidden" src="@/assets/icons/burger-menu-icon.svg" alt="">
                        <img v-if="sidebarOpen" @click="sidebarOpen = !sidebarOpen" class="absolute left-0 lg:hidden" src="@/assets/icons/close.svg" alt="">
                        <div class="hidden lg:flex justify-start items-center absolute left-0">
                            <div @click="mailingListModal?.open()" class="cursor-pointer flex items-center">
                                <div class="h-10 w-10 rounded-full bg-sn-orange overflow-hidden flex justify-center items-center">
                                    {{ user?.first_name.substring(0,1) }}
                                </div>
                                <span class="ml-1.5" v-text="user?.first_name"></span>
                            </div>
                        </div>
                        <img class="hidden lg:block max-h-full mr-10" src="/img/logo.svg" alt="">
                        <div class="flex items-center justify-end gap-x-4 absolute right-0">
                            <span v-if="noticeText" class="px-2 py-0.5 rounded text-xs font-medium text-white whitespace-nowrap" :style="{ background: noticeColor }" v-text="noticeText"></span>
                            <div class="flex items-center relative">
                                <span v-if="unreadNotificationCount" class="pointer-events-none rounded-full bg-sn-orange border border-sn-orange-dark w-5 h-5 absolute -top-2.5 -left-2.5 flex justify-center items-center text-white text-xs">
                                    {{ unreadNotificationCount }}
                                </span>
                                <i ref="notificationsIcon" class="fal cursor-pointer fa-bell text-lg" @click="toggleNotifications"></i>
                                <div v-if="notificationsOpen" ref="notificationsDropdown" class="absolute select-none bg-white shadow-xl w-[400px] top-6 right-0 border rounded-lg">
                                    <div v-if="notifications?.data?.length" class="p-2 flex justify-between border-b">
                                        <Button @click="readAllNotifications" type="primary" size="small">Mark all as read</Button>
                                        <Button @click="deleteAllNotifications" type="primary" colour="red" size="small">Delete all</Button>
                                    </div>
                                    <div @click.exact="readNotification(notification)" v-for="notification in notifications?.data"
                                         class="p-2 cursor-pointer flex items-center gap-4 relative"
                                         :class="{'bg-sn-superlight-blue bg-opacity-30': !notification.read_at}">
                                        <i @click="deleteNotification(notification)" class="absolute top-2 right-2 fal fa-trash fad text-sn-dark-red cursor-pointer"></i>
                                        <i :class="notification.icon" class="fad text-2xl"></i>
                                        <div class="flex flex-col gap-1">
                                            <h4 class="text-lg" v-text="notification.data.title"></h4>
                                            <NuxtLink :to="notification.data.url">
                                                <Button type="primary" size="small" v-text="notification.data.url_text"></Button>
                                            </NuxtLink>
                                            <p class="italic text-sm" v-text="timeAgo(notification.created_at)"></p>
                                        </div>
                                    </div>
                                    <Pagination @change-page="fetchNotifications" v-if="notifications?.data?.length" :current-page="notifications?.current_page" :total-pages="notifications?.last_page" class="pb-4 px-4" />
                                    <div v-if="!notifications?.data?.length" class="p-4">
                                        You have no notifications
                                    </div>
                                </div>
                            </div>
                            <SideCart />
                        </div>
                    </div>
                </Container>
            </div>

            <div class="hidden lg:block">
                <Container class="flex justify-center items-center h-10 bg-white border-b border-[rgba(0,0,0,0.05)]">
                    <template
                        v-for="navLink in topNavLinks"
                    >
                        <NuxtLink
                            v-if="hasAnyRoutePermission(navLink.permissions)"
                            class="topNavLink"
                            :class="{
                                'activeTopNavLink': linkIsActive(navLink.link)
                            }"
                            :to="navLink.link"
                            v-text="navLink.title"
                        />
                    </template>
                </Container>
            </div>
        </header>

        <div>
            <div @click="desktopSidebarOpen = !desktopSidebarOpen"
                 class="hidden cursor-pointer transition-all duration-300 fixed top-1/2 translate-y-[-41px] h-[92px] lg:flex flex-col justify-between align-items-start"
                 :class="{'left-[248px]': desktopSidebarOpen, 'left-11': !desktopSidebarOpen}"
            >
                <div class="h-full absolute left-0 w-0.5 bg-sn-orange rounded-r-xl"></div>
                <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0C-2.86168e-07 3.31365 2.68638 5.9999 6 6H0V0Z" fill="white"/>
                </svg>
                <div class="flex justify-center items-center w-4 rounded-r-lg flex-1 bg-white">
                    <i class="fal fa-chevron-right text-sm" :class="{'transform rotate-180': desktopSidebarOpen}"></i>
                </div>
                <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 0C2.68629 1.72001e-06 3.59416e-07 2.68629 -2.62268e-07 6L0 -2.62268e-07L6 0Z" fill="white"/>
                </svg>
            </div>
            <div
                class="w-[309px] overflow-x-hidden transition-all z-20 duration-300 top-0 left-0 pt-[73px] lg:pt-[139px] h-full bg-white overflow-y-hidden fixed"
                :class="{'translate-x-[-320px] lg:translate-x-0': !sidebarOpen, 'lg:w-[248px]': desktopSidebarOpen, 'lg:w-11': !desktopSidebarOpen}"
            >
                <svg class="absolute hidden lg:block z-10 top-[147px] cursor-pointer transition-all duration-300"
                     :class="{'-right-44': !desktopSidebarOpen, 'right-2': desktopSidebarOpen}"
                     @click="toggleSidebarPinned"
                     width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.23201 8.23216L13.5353 3.63597L17.0708 6.4644L12.1211 11.4141L11.414 14.2426L5.40358 8.23216H8.23201Z" :class="{'fill-white': !sidebarPinned, 'fill-sn-orange': sidebarPinned}"/>
                    <path d="M12.47 11.6747L12.5142 14.5567L11.6713 15.3995L8.57031 12.2986L5.19889 15.67L4.34292 15.6569L4.3298 14.8009L7.70122 11.4295L4.60023 8.32848L5.44309 7.48562L8.32509 7.52979L12.7413 3.11356L11.9391 2.31132L12.7819 1.46846L18.5313 7.21784L17.6885 8.0607L16.8862 7.25846L12.47 11.6747ZM6.67219 8.71472L11.2851 13.3276L11.2518 11.1547L16.0171 6.38936L13.6104 3.98265L8.84504 8.74802L6.67219 8.71472Z" fill="#CF7D0A"/>
                </svg>

                <div class="relative h-full">
                    <div class="overflow-y-scroll h-full max-h-full pt-4 lg:pt-6 sidebarNavContainer" :class="noticeText ? 'pb-60' : 'pb-52'">
                        <div @click="mailingListModal?.open()" class="flex lg:hidden justify-start items-center pl-[14px] pb-2">
                            <div class="h-10 w-10 rounded-full bg-sn-orange overflow-hidden flex justify-center items-center">
                                <span v-text="user?.first_name.slice(0,1)"></span>
                            </div>
                            <!--                            <img class="h-10 w-10 rounded-full bg-sn-orange overflow-hidden" src="" alt="">-->
                            <span class="ml-1.5" v-text="user?.first_name"></span>
                        </div>
                        <NuxtLink v-for="link in userRoutes"
                            class="flex w-full h-10 justify-start items-center pl-[10px] sideNavLink"
                            :class="{
                                'bg-red-200': inDevelopment && !userRoutes.includes(link),
                                'activeSideNavLink': linkIsActive(link.url)
                            }"
                            :to="link.url"
                        >
                            <span class="inline-flex flex-shrink-0 justify-center items-center mr-2">
                                <img class="w-[18px] h-[18px]" :src="`/img/${link.icon}.svg`" alt="" />
                            </span>
                            <span class="transition-all duration-300 whitespace-nowrap overflow-hidden w-full" :class="{'lg:w-[199px]': desktopSidebarOpen, 'lg:w-0': !desktopSidebarOpen}" v-text="link.name"></span>
                        </NuxtLink>
                    </div>

                    <div class="p-4 bg-white flex flex-col shadow-cover-scroll-top absolute left-0 bottom-0 w-full">
                        <NuxtLink
                            class="h-[37px] flex justify-start items-center"
                            to="/logout"
                        >
                            <span class="inline-flex justify-center items-center w-4 mr-2">
                                <i class="fal fa-sign-out"></i>
                            </span>
                            <span class="transition-all duration-300 whitespace-nowrap overflow-hidden w-full" :class="{'lg: w-[199px]': desktopSidebarOpen, 'lg:w-0': !desktopSidebarOpen}">Logout</span>
                        </NuxtLink>
                        <NuxtLink
                            class="h-[37px] flex justify-start items-center"
                            to="/terms-of-use"
                        >
                            <span class="inline-flex justify-center items-center w-4 mr-2">
                                <i class="fal fa-file-check"></i>
                            </span>
                            <span class="transition-all duration-300 whitespace-nowrap overflow-hidden w-full" :class="{'lg:w-[199px]': desktopSidebarOpen, 'lg:w-0': !desktopSidebarOpen}">Terms of use</span>
                        </NuxtLink>
                        <NuxtLink
                            class="h-[37px] flex justify-start items-center"
                            to="/contact"
                        >
                            <span class="inline-flex justify-center items-center w-4 mr-2">
                                <i class="fal fa-envelope"></i>
                            </span>
                            <span class="transition-all duration-300 whitespace-nowrap overflow-hidden w-full" :class="{'lg:w-[199px]': desktopSidebarOpen, 'lg:w-0': !desktopSidebarOpen}">Contact us</span>
                        </NuxtLink>
                        <span @click="changePasswordModal?.open()" class="cursor-pointer h-[37px] flex justify-start items-center">
                            <span class="inline-flex justify-center items-center w-4 mr-2">
                                <i class="fal fa-user-lock"></i>
                            </span>
                            <span class="transition-all duration-300 whitespace-nowrap overflow-hidden w-full" :class="{'lg:w-[199px]': desktopSidebarOpen, 'lg:w-0': !desktopSidebarOpen}">Change Password</span>
                        </span>
                        <span class="h-6 flex items-end text-sm text-gray-400 transition-all duration-300 whitespace-nowrap overflow-hidden w-full" :class="{'lg:w-[199px]': desktopSidebarOpen, 'lg:w-0': !desktopSidebarOpen}" v-text="appVersion"></span>
                        <div v-if="noticeText" class="-mx-4 -mb-4 mt-2 px-4 h-10 flex justify-start items-center text-base font-medium text-white" :style="{ background: noticeColor }" :title="noticeText">
                            <span class="inline-flex justify-center items-center w-4 mr-2 shrink-0">
                                <i class="fal fa-exclamation-triangle"></i>
                            </span>
                            <span class="transition-all duration-300 whitespace-nowrap overflow-hidden w-full" :class="{'lg:w-[199px]': desktopSidebarOpen, 'lg:w-0': !desktopSidebarOpen}" v-text="noticeText"></span>
                        </div>

<!--                        <NuxtLink-->
<!--                            class="h-[37px] flex justify-start items-center"-->
<!--                            to="/settings"-->
<!--                        >-->
<!--                            <span class="inline-flex justify-center items-center w-4 mr-2">-->
<!--                                <i class="fal fa-cog"></i>-->
<!--                            </span>-->
<!--                            <span class="transition-all duration-300 whitespace-nowrap overflow-hidden w-full" :class="{'lg:w-[199px]': desktopSidebarOpen, 'lg:w-0': !desktopSidebarOpen}">Settings</span>-->
<!--                        </NuxtLink>-->
                    </div>
                </div>
            </div>

            <div class="pt-[73px] lg:pt-[139px] transition-all duration-300 min-h-screen bg-sn-light-grey"
                 :class="{'lg:pl-[248px]': desktopSidebarOpen, 'lg:pl-11': !desktopSidebarOpen}"
            >

                <slot />

            </div>

        </div>

        <ErrorModal />
        <WarningModal />

        <MailingListModal ref="mailingListModal" />
        <ChangePasswordModal ref="changePasswordModal" />

        <Cookies />
    </div>

</template>

<style scoped>

    .topNavLink {
        @apply h-full px-4 flex justify-center items-center border-t-4 border-transparent
    }

    .activeTopNavLink {
        @apply border-sn-orange font-semibold bg-sn-light-grey
    }

    .sideNavLink {
        @apply flex justify-center items-center border-l-4 border-transparent
    }

    .activeSideNavLink {
        @apply border-sn-orange font-semibold bg-sn-light-grey
    }

    .sidebarNavContainer {
        scrollbar-color: transparent transparent;
        scrollbar-width: thin;
        transition: all 300ms;
    }
    .sidebarNavContainer:hover {
        scrollbar-color: #C7C7C7 transparent;
    }

</style>

<script setup lang="ts">

import Container from "@/components/core/Container.vue";
import { routes } from "@/config/routes";
import { useApiUser } from "@/composables/useApiUser";
import {useNotifications} from "@/composables/useNotifications";
import Button from "@/components/core/Button.vue";
import {timeAgo} from "@/composables/useDate";
import Pagination from "@/components/tables/Pagination.vue";
import {onClickOutside} from "@vueuse/core";
import SideCart from "@/components/orderProcess/SideCart.vue";
import ErrorModal from "@/components/core/modals/ErrorModal.vue";
import Permissions from "@/config/Permissions";
import {useApi} from "@/composables/useApi";
import WarningModal from "@/components/core/modals/WarningModal.vue";
import ChangePasswordModal from "@/components/core/modals/ChangePasswordModal.vue";
import MailingListModal from "@/components/core/modals/MailingListModal.vue";

const notificationsOpen = ref(false);
const route = useRoute();
// Filled from the Laravel install at runtime, see server/plugins/laravelEnv.ts;
const { appVersion, noticeText, noticeColor } = useRuntimeConfig().public;

const { notifications, fetchNotifications, readNotification, readAllNotifications, deleteAllNotifications, deleteNotification, unreadNotificationCount, fetchUnreadNotificationCount } = useNotifications();
const notificationsElement = useTemplateRef<HTMLElement>('notificationsDropdown');
const notificationsIcon = useTemplateRef<HTMLElement>('notificationsIcon');
const mailingListModal = ref<InstanceType<typeof MailingListModal>|null>(null);
const changePasswordModal = ref<InstanceType<typeof ChangePasswordModal>|null>(null);

async function toggleNotifications() {
    if(!notificationsOpen.value) {
        await fetchNotifications();
    }
    notificationsOpen.value = !notificationsOpen.value;
}

function toggleSidebarPinned() {
    sidebarPinned.value = !sidebarPinned.value;
    if(import.meta.client){
        if(sidebarPinned.value) {
            localStorage.setItem("sidebarPinned", String(sidebarPinned.value));
            return;
        }
        localStorage.removeItem("sidebarPinned");
    }
}

onClickOutside(
    notificationsElement,
    (event) => {
        notificationsOpen.value = false;
    },
    { ignore: [notificationsIcon]}
)

fetchUnreadNotificationCount();

setInterval(() => {
    fetchUnreadNotificationCount();
}, 60000)

const user = useApiUser();

const topNavLinks = ref<{title: string, link: string, permissions: string[]}[]>([
    {
        title: 'Home',
        link: '/',
        permissions: [
            Permissions.ORDER_CREATE
        ],
    },
    {
        title: 'Orders',
        link: [1,2].includes(user.value?.role_id) ? '/admin/orders' : '/orders',
        permissions: [1,2].includes(user.value?.role_id) ? [] : [Permissions.ORDER_ASSIGNED_VIEW_ALL],
    },
    {
        title: 'Education',
        link: '/education',
        permissions: [
            Permissions.CMS_CONTAINER_EDUCATION_CCG_VIEW,
            Permissions.CMS_CONTAINER_CCG_VIEW
        ],
    }
]);

const { data: helpdeskEnabled, fetch: fetchHelpdeskEnabled } = useApi<{is_helpdesk_enabled: boolean}>({
    url: 'helpdesk/enabled',
    method: 'GET',
});

onMounted(async () => {
    await fetchHelpdeskEnabled();
    if(helpdeskEnabled.value?.is_helpdesk_enabled) {
        topNavLinks.value.push({
            title: 'Support',
                link: '/support/dashboard',
                permissions: [
            ],
        });
    }
});

// const topNavLinks = <Record<string,string>> {
//     [homeRouteName]:  (user.value?.role_id && [3,4,8].includes(user.value?.role_id)) ? '/' : '/dashboard',
//     'Orders': ordersRoute,
//     'Education': '/education',
//     'Support': '/support/dashboard',
// };

const sidebarOpen = ref(false);
const desktopSidebarOpen = ref(false);
const sidebarPinned = ref(false);

if(import.meta.client) {
    sidebarPinned.value = localStorage.getItem("sidebarPinned") === "true";
    desktopSidebarOpen.value = sidebarPinned.value;
}

const inDevelopment = computed(() => {
    return process.env.NODE_ENV === 'development';
})

let userRoutes = routes.filter((route) => {
    if(route.name === 'Home') {
        return false;
    }
    if(user.value?.all_permissions) {
        if(user.value?.all_permissions?.map((p) => p.name).includes('system.admin.override')) {
            return true;
        }
    }
    if(typeof route.permissions === 'undefined' || route.permissions === null || route.permissions.length === 0) {
        return true;
    }

    if(user.value?.all_permissions) {
        if(route.permissions.some((p) => user.value?.all_permissions.map(perm => perm.name).includes(p))) {
            return true;
        }
    }

    return false;
}).map((route) => {
    if(route.url.includes('{channel.id}') && user.value.channels?.length) {
        route.url = route.url.replace('{channel.id}', user.value.channels[0].id);
    }
    return route;
});

let mappedRoutes = routes.map((route) => {
    if (route.url.includes('{channel.id}') && user.value.channels?.length) {
        route.url = route.url.replace('{channel.id}', user.value.channels[0]?.id ?? 1);
    }
    return route;
});

function hasAnyRoutePermission(permissions: string[]) {
    if(!permissions.length) {
        return true;
    }

    if(user.value && user.value?.all_permissions.filter((p) => permissions.includes(p.name)).length > 0) {
        return true;
    }
    return false;
}

function linkIsActive(link: string) {
    if(link === '/') {
        return route.path === link;
    }
    return route.path.startsWith(link);
}

</script>